// src/components/Footer.tsx
import { Coffee, Instagram, Facebook, Twitter, Heart } from 'lucide-react';
import { Link } from 'react-router-dom';

const Footer = () => {
  const currentYear = new Date().getFullYear();
  
  return (
    <footer className="bg-coffee-900 text-white">
      <div className="container-custom py-16">
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
          <div className="footer-card">
            <Link to="/" className="flex items-center gap-2 mb-4">
              <Coffee className="h-8 w-8 text-coffee-300" />
              <h2 className="text-2xl font-serif font-semibold text-white">moca</h2>
            </Link>
            <p className="text-coffee-300 mb-6">
              Elevating your coffee experience with carefully sourced beans and expert roasting.
            </p>
            <div className="flex gap-4">
              <SocialLink href="https://instagram.com" icon={<Instagram size={20} />} />
              <SocialLink href="https://facebook.com" icon={<Facebook size={20} />} />
              <SocialLink href="https://twitter.com" icon={<Twitter size={20} />} />
            </div>
          </div>
          
          <div className="footer-card">
            <h3 className="text-lg font-medium mb-4 text-white">Quick Links</h3>
            <ul className="space-y-3">
              <FooterLink to="/">Home</FooterLink>
              <FooterLink to="/about">About Us</FooterLink>
              <FooterLink to="/menu">Shop</FooterLink>
              <FooterLink to="/contact">Contact</FooterLink>
            </ul>
          </div>
          
          <div className="footer-card">
            <h3 className="text-lg font-medium mb-4 text-white">Our Coffee</h3>
            <ul className="space-y-3">
              <FooterLink to="/menu">Single Origin</FooterLink>
              <FooterLink to="/menu">Blends</FooterLink>
              <FooterLink to="/menu">Subscriptions</FooterLink>
              <FooterLink to="#">Brewing Guides</FooterLink>
            </ul>
          </div>
          
          <div className="footer-card">
            <h3 className="text-lg font-medium mb-4 text-white">Contact</h3>
            <ul className="space-y-3 text-coffee-300">
              <li>123 Coffee Street</li>
              <li>San Francisco, CA 94110</li>
              <li>hello@mocacoffee.com</li>
              <li>(555) 123-4567</li>
            </ul>
          </div>
        </div>
        
        <div className="border-t border-coffee-700 mt-12 pt-8 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-coffee-400 text-sm">
            © {currentYear} Moca Coffee. All rights reserved.
          </p>
          <p className="text-coffee-400 text-sm">
            Made with{' '}
            <Heart size={16} className="inline text-coffee-400 animate-pulse" /> by{' '}
            <a
              href="https://digitalpro.dev/"
              className="text-coffee-400 underline hover:text-white transition-colors"
              target="_blank"
              rel="noopener noreferrer"
            >
              DigitalPro
            </a>
          </p>
          <div className="flex gap-6 text-coffee-400 text-sm">
            <a href="#" className="hover:text-white transition-colors">Privacy Policy</a>
            <a href="#" className="hover:text-white transition-colors">Terms of Service</a>
            <a href="#" className="hover:text-white transition-colors">Shipping Policy</a>
          </div>
        </div>
      </div>
    </footer>
  );
};

const SocialLink = ({ href, icon }: { href: string; icon: React.ReactNode }) => (
  <a 
    href={href}
    target="_blank"
    rel="noopener noreferrer" 
    className="bg-coffee-800 p-2 rounded-full hover:bg-coffee-600 transition-colors"
  >
    {icon}
  </a>
);

const FooterLink = ({ to, children }: { to: string; children: React.ReactNode }) => (
  <li>
    <Link 
      to={to} 
      className="text-coffee-300 hover:text-white transition-colors"
    >
      {children}
    </Link>
  </li>
);

export default Footer;